import { render, staticRenderFns } from "./TimePicker.vue?vue&type=template&id=4f65f5b6&scoped=true&"
import script from "./TimePicker.vue?vue&type=script&lang=js&"
export * from "./TimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65f5b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VDialog,VTimePicker})
